import apiClient from './api';
import type { PaginatedResponse } from '@/types';

const BASE_URL = '/import-logs';

export interface ImportLog {
  id: number;
  type: string;
  nomFichier: string | null;
  utilisateur: {
    id: number;
    nom: string;
    prenom: string;
    email: string;
  };
  dateImport: string;
  nombreLignes: number;
  nombreImportes: number;
  nombreIgnores: number;
  succes: boolean;
  messageGlobal: string | null;
  erreurs: string[] | null;
}

/**
 * Service API pour le rapport des imports de donnees (vacations, etc.)
 */
export const importLogService = {
  async list(page = 1, limit = 20, type?: string): Promise<PaginatedResponse<ImportLog>> {
    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('limit', String(limit));
    if (type) {
      params.append('type', type);
    }

    const response = await apiClient.get<PaginatedResponse<ImportLog>>(
      `${BASE_URL}?${params.toString()}`
    );
    return response.data;
  },
};

export default importLogService;
